import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/inici',
		name: 'Inici',
		component: Home,
		alias: '/'
	},
	{
		path: '/sobre-el-projecte',
		name: 'Sobre el projecte',
		component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
	},
	{
		path: '*',
		name: '404',
		component: () => import('../views/404.vue')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
